<template>
  <div class="modal-view">
    <div class="p-4">
      <slot />
    </div>
    <div class="p-4 text-right">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {}
</script>


